var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle118(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "438.0232187736063 93.88999999999997 15.616781226393755 17.578174980266553",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M449.64,102.8c-.27.85-.48,2.02-1.01,3.02-.56,1.07-1.61,1.73-2.89,1.64-1.39-.1-2.54-.68-3.14-2.03-.75-1.68-.76-3.4-.08-5.11.6-1.52,1.88-2.43,3.32-2.43,1.62,0,2.93,1.08,3.41,2.86.15.56.22,1.14.39,2.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle118);
export default __webpack_public_path__ + "static/media/twinkle-1-18.a067d7a281fd6979eff1b3cd8f25406b.svg";
export { ForwardRef as ReactComponent };